import React, { useState } from "react";
import "./NoResult.css";
import Button from "../../components/Button/Button";
import { Globals } from "../../global/Globals";

export default function NoResultsComponent({ data, handleReload }) {
  return (
    <>
      <div className={data?.outerWrapper || "NoResultsComponent"}>
        <img className={data?.imgWrapper || "HalfPageWrapperImg"} src={data?.img} />
        <h4 className={data?.className || " messageNoresults"}>{data?.message}</h4>
        <p
          className={data?.subclassName || "submessageNoresults"}
          style={{ color: "var(--text-secondary, #5c5c5d)" }}
        >
          {data?.submessage}
        </p>
        {data?.button === "reload" && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "16px",
            }}
          >
            {" "}
            <Button
              title={Globals.HALFSCREEN.RELOAD_BTN}
              id="Half-Screen-Apply-Button"
              additionalStyle="apply-button"
              action={handleReload}
            />
          </div>
        )}
      </div>
    </>
  );
}
